import { Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

export interface IllustrationCardProps {
  illustration: ReactNode;
  action: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
}

export function IllustrationCard({
  illustration,
  action,
  title,
  description,
}: IllustrationCardProps): JSX.Element {
  const { isPhone } = useScreenSizes();
  const isHorizontal = !!title;

  if (!isHorizontal) {
    return (
      <Flex flexDirection="column" alignItems="center">
        <Stack y="md">{illustration}</Stack>
        <Flex
          width={isPhone ? '100%' : '60%'}
          justifyContent="center"
          alignItems="center"
        >
          {action}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" height="100%">
      <Flex flexDirection="row" alignItems="stretch" height="100%">
        <Flex flexShrink={0} alignItems="center" height="100%">
          <Stack x="md">{illustration}</Stack>
        </Flex>
        <Flex
          flexDirection="column"
          flex={1}
          height="100%"
          justifyContent="space-between"
        >
          <Stack y={isPhone ? 'lg' : 'md'}>
            <Stack y="xxx-sm">{title}</Stack>
            {description}
          </Stack>
          {!isPhone && <Stack style={{ flexShrink: 0 }}>{action}</Stack>}
        </Flex>
      </Flex>
      {isPhone && <Stack>{action}</Stack>}
    </Flex>
  );
}
